var render = function render(){var _vm=this,_c=_vm._self._c;return _c('stats-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"title":"Tempo médio de quitação","type":"danger","sub-title":`${_vm.value}`,"icon":"ni ni-time-alarm"}})
}
var staticRenderFns = []

export { render, staticRenderFns }